import { FinancialDisclaimerType } from '~/app/market-config/models/financial-disclaimer-type';
import { FinancingDisclaimer } from '~/graphql/__generated__/graphql';

const getMonthlyRateDisclaimer = (
	financingDisclaimerType: FinancialDisclaimerType[],
	financingDisclaimers: FinancingDisclaimer[] | undefined,
) => {
	return (
		financingDisclaimerType
			.flatMap((disclaimer) =>
				financingDisclaimers?.filter((a) => disclaimer.startsWith(a.key.toLowerCase())).map((a) => a.text),
			)
			.join(' ') ?? ''
	);
};

export { getMonthlyRateDisclaimer };
